<template>
  <div class="continer">
    <div class="center">
      <!-- <ul>
        <li v-for="(item,index) in routerList" :key="index">{{item.label}}</li>
      </ul> -->
      <!-- <router-link :to="item.url" v-for="(item,index) in routerList" :key="index" @click.native="showIndex = index" :class="{'active':showIndex == index}">{{item.label}}</router-link> -->
      <router-link :to="item.url" active-class="active" exact v-for="(item,index) in routerList" :key="index">{{item.label}}</router-link>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // showIndex:0,
      routerList: [
        {
          label: "首页",
          url: "/"
        },
        {
          label: "审查流程",
          url: "/drawing"
        },
        {
          label: "交流园地",
          url: "/alternating"
        },
        {
          label: "审查成果",
          url: "/result"
        },
        {
          label: "政策法规",
          url: "/policy"
        },
        {
          label: "通知中心",
          url: "/blogroll"
        },
        {
          label: "了解我们",
          url: "/understand"
        },
      ]
    }
  },
  mounted(){
    // this.onChange()
  },
  methods:{

  }
}
</script>
<style lang="stylus" scoped>
// & > router-link
//   display: block
//   font-size: 14px
//   color: rgb(77, 85, 93)
// & > a.active
//   color: rgb(240, 20, 20)
.router-link-active
  background #3377ff
  color #fff !important 
.active
  background #3377ff
  color #fff !important 
.continer 
  width 100%
  background #f0f0f0
  height 58px
  .center
    width 1200px
    margin 0 auto
    text-align left
    a
      display inline-block
      width 98px
      height 58px
      color #000
      line-height 58px
      text-align center
      // font-size 14px
      // &:hover
      //    background #3377ff
      //    color #fff
</style>